// extracted by mini-css-extract-plugin
module.exports = {"backToTop":"BackToTop_backToTop__11_G8"};